import type { PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http';
import { PsHttpService } from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';

export interface ReportValidationRequest {
  flow_id: string;
  first_image: string;
}

export interface ValidationApi {
  reportValidation(data: ReportValidationRequest): Promise<string>;
  uploadFishBoneChartScreenShot(
    job_id: string,
    formData: FormData
  ): Promise<string>;
}

export const ValidationApi = Symbol('ValidationApi');

@injectable()
export class ValidationApiImpl extends PsHttpService implements ValidationApi {
    get options() {
        return {
            baseURL: `${
                import.meta.env.VITE_EUREKA_SERVICE_URI
            }/eureka/agent/validation`,
            headers: {
                'X-API-Version': '1.0',
            },
        };
    }

    reportValidation(data: ReportValidationRequest) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: '/report/export',
            data,
        }).then((res) => {
            return res.data as string;
        });
    }

    /**
   * 上传鱼骨图截图
   */
    uploadFishBoneChartScreenShot(job_id: string, formData: FormData) {
        return this.post<PatSnapCommonResponseData<string>>({
            url: `/push-diagram/${job_id}`,
            data: formData,
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }).then((res) => {
            return res.data as string;
        });
    }
}
